import { render, staticRenderFns } from "./DailyTable.vue?vue&type=template&id=b904acfa&lang=pug"
import script from "./DailyTable.vue?vue&type=script&lang=js"
export * from "./DailyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports